import { render, staticRenderFns } from "./BarLeft.vue?vue&type=template&id=67d20dba&"
import script from "./BarLeft.vue?vue&type=script&lang=js&"
export * from "./BarLeft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports